import React from 'react';
import classNames from 'classnames';

function TextSkeleton({ className }: { className?: string }) {
  return (
    <div role="status" className={classNames("space-y-2.5 animate-pulse", className)}>
      <div className="flex items-center w-full">
        <div className="h-2.5 bg-gray-200 rounded-full w-32"></div>
        <div className="h-2.5 ms-2 bg-gray-300 rounded-full w-24"></div>
        <div className="h-2.5 ms-2 bg-gray-300 rounded-full w-full"></div>
      </div>
      <div className="flex items-center w-full max-w-[480px]">
        <div className="h-2.5 bg-gray-200 rounded-full w-full"></div>
        <div className="h-2.5 ms-2 bg-gray-300 rounded-full w-full"></div>
        <div className="h-2.5 ms-2 bg-gray-300 rounded-full w-24"></div>
      </div>
      <div className="flex items-center w-full max-w-[400px]">
        <div className="h-2.5 bg-gray-300 rounded-full w-full"></div>
        <div className="h-2.5 ms-2 bg-gray-200 rounded-full w-80"></div>
        <div className="h-2.5 ms-2 bg-gray-300 rounded-full w-full"></div>
      </div>
      <div className="flex items-center w-full max-w-[480px]">
        <div className="h-2.5 bg-gray-200 rounded-full w-full"></div>
        <div className="h-2.5 ms-2 bg-gray-300 rounded-full w-full"></div>
        <div className="h-2.5 ms-2 bg-gray-300 rounded-full w-24"></div>
      </div>
      <div className="flex items-center w-full max-w-[440px]">
        <div className="h-2.5 bg-gray-300 rounded-full w-32"></div>
        <div className="h-2.5 ms-2 bg-gray-300 rounded-full w-24"></div>
        <div className="h-2.5 ms-2 bg-gray-200 rounded-full w-full"></div>
      </div>
      <div className="flex items-center w-full max-w-[360px]">
        <div className="h-2.5 bg-gray-300 rounded-full w-full"></div>
        <div className="h-2.5 ms-2 bg-gray-200 rounded-full w-80"></div>
        <div className="h-2.5 ms-2 bg-gray-300 rounded-full w-full"></div>
      </div>
      <span className="sr-only">Loading...</span>
    </div>
  )
}

export default TextSkeleton